/* eslint-disable import/prefer-default-export */
import { createNavigation } from '../lib/utils'
import { OrganizationNavigation } from './OrganizationNavigation'

// TODO - fix correct dynamic type generation for autocomplete
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const SettingsNavigation = createNavigation([
  {
    name: 'settings',
    path: OrganizationNavigation.organization.settings.route.pathname,
    subroutes: [
      {
        name: 'account',
        path: '/account',
      },
      {
        name: 'workspace',
        path: '/workspace',
        subroutes: [
          {
            name: 'ai',
            path: '/ai-settings',
          },
          {
            name: 'announcements',
            path: '/announcements',
          },
          {
            name: 'billing',
            path: '/billing',
          },
          {
            name: 'changelog',
            path: '/change-log',
            subroutes: [
              {
                name: 'productIdeas',
                path: '/product-ideas',
              },
              {
                name: 'releaseNotes',
                path: '/release-notes',
              },
            ],
          },
          {
            name: 'publicPages',
            path: '/public-pages',
            subroutes: [
              {
                name: 'publicPage',
                path: '/[pageId]',
              },
            ],
          },
          {
            name: 'groups',
            path: '/groups',
          },
          {
            name: 'integrations',
            path: '/integrations',
            subroutes: [
              {
                name: 'clariCopilot',
                path: '/clari-copilot',
              },
              {
                name: 'gong',
                path: '/gong',
              },
              {
                name: 'hubspot',
                path: '/hubspot',
              },
              {
                name: 'intercom',
                path: '/intercom',
              },
              {
                name: 'microsoftDynamics',
                path: '/microsoft-dynamics',
              },
              {
                name: 'pipedrive',
                path: '/pipedrive',
              },
              {
                name: 'salesforce',
                path: '/salesforce',
              },
              {
                name: 'zendesk',
                path: '/zendesk',
              },
              {
                name: 'zoom',
                path: '/zoom',
              },
              {
                name: 'slack',
                path: '/slack',
              },
            ],
          },
          {
            name: 'members',
            path: '/members',
          },
          {
            name: 'productManagement',
            path: '/product-management',
            subroutes: [
              {
                name: 'prioritizationFactors',
                path: '/prioritization-factors',
              },
              {
                name: 'status',
                path: '/status',
              },
            ],
          },
          {
            name: 'tags',
            path: '/tags',
          },
          {
            name: 'templates',
            path: '/templates',
            subroutes: [
              {
                name: 'gtmPhases',
                path: '/gtm-phases',
              },
              {
                name: 'savedTemplates',
                path: '/saved-templates',
              },
            ],
          },
          {
            name: 'user',
            path: '/user',
          },
        ],
      },
    ],
  },
] as const)
